export default __webpack_public_path__ + "static/media/g1.542ecdf2.webp";